import { isDealersShopUri, uriIncludesVertical, isMoreFromSeller } from './uriUtils';
import { TYPES } from '../constants/favoritesConstants';

/**
 * @param uri - uri string
 * @param isOnlyFetching - If true will return an array of types that count as follows
 */
export const getFollowTypeFromUri = (uri = '', isOnlyFetching = false) => {
    const isDealer = isDealersShopUri(uri) && !uriIncludesVertical(uri);
    if (isDealer || isMoreFromSeller(uri)) {
        return isOnlyFetching ? [TYPES.DEALER] : TYPES.DEALER;
    }

    return isOnlyFetching ? [TYPES.SEARCH, TYPES.USER_PREFERENCE] : TYPES.SEARCH;
};
